import React from 'react'
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from 'react-share'
import {
  faFacebook,
  faLinkedin,
  faTwitter,
} from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import classes from './share.module.scss'
import { faShare, faShareAlt } from '@fortawesome/pro-regular-svg-icons'
import PropTypes from 'prop-types'

const Share = ({ url, title, hideHeading, size }) => {
  const webShare = async () => {
    if (navigator && navigator.share) {
      try {
        await navigator
          .share({
            url,
            title,
          })
          .then(() =>
            console.log('Hooray! Your content was shared to tha world')
          )
      } catch (error) {
        console.log(`Oops! I couldn't share to the world because: ${error}`)
      }
    }
  }
  return (
    <div className={`${classes.sharer} ${size ? classes[size] : ''}`}>
      {!hideHeading && <span>Share This Page: </span>}
      <button
        className={classes.webShare}
        title={title}
        aria-label={'Web Share'}
        onClick={webShare}
      >
        <FontAwesomeIcon icon={faShareAlt} />
      </button>
      <FacebookShareButton
        url={`https://${
          window && window.location.hostname ? window.location.hostname : ''
        }${url}`}
        title={title}
        className={classes.facebook}
      >
        <FontAwesomeIcon icon={faFacebook} />
      </FacebookShareButton>
      <TwitterShareButton
        url={`https://${
          window && window.location.hostname ? window.location.hostname : ''
        }${url}`}
        title={title}
        className={classes.facebook}
      >
        <FontAwesomeIcon icon={faTwitter} />
      </TwitterShareButton>
      <LinkedinShareButton
        url={`https://${
          window && window.location.hostname ? window.location.hostname : ''
        }${url}`}
        title={title}
        className={classes.facebook}
      >
        <FontAwesomeIcon icon={faLinkedin} />
      </LinkedinShareButton>
    </div>
  )
}
Share.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  hideHeading: PropTypes.bool,
  size: PropTypes.string,
}
export default Share
